import { ComponentRef } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { ModalContainerComponent } from '../modal-container/modal-container.component';
import { Modal } from './modal.model';

export class ModalRef {
  private result = new Subject<any>();
  private close = new Subject<void>();

  constructor(
    private modalContainer: ComponentRef<ModalContainerComponent>,
    private modal: ComponentRef<Modal>
  ) {
    this.modal.instance.modalInstance = this;
  }

  accept(output?: any): void {
    output ?? this.result.next(output);
    this.autoDestroy();
  }

  dismiss(): void {
    this.autoDestroy();
  }

  /**
   * Returns an observable that is triggered when the modal is accepted with a value
   */
  get onResult$(): Observable<any> {
    return this.result.asObservable();
  }

  /**
   * Returns an observable that is triggered when the modal is closed
   * in any way (accepted or dismissed)
   */
  get onClose$(): Observable<void> {
    return this.close.asObservable();
  }

  private autoDestroy(): void {
    this.close.next();
    this.modal.destroy();
    this.modalContainer.destroy();
    this.result.complete();
  }
}
